"use client";
import {
  fallbackChainId
} from "@/constants/chain-specific/chains";
import type { RequiredAggregatorChainType, RequiredTokenListType } from "@/constants/project-specific";
import { pinnedTokens } from "@/constants/project-specific/tokens";
import type { TokenConfigType } from "@/constants/types/currency";

type InitialTokenReturnType = {
  in: TokenConfigType;
  out: TokenConfigType;
};

export const getInitialToken = (
  chainId: RequiredTokenListType | undefined
): InitialTokenReturnType => {
  return {
    in: pinnedTokens[(chainId as RequiredTokenListType) ?? fallbackChainId]?.swapDefaultFrom[0] ?? pinnedTokens[fallbackChainId].swapDefaultFrom[0],
    out: pinnedTokens[(chainId as RequiredTokenListType) ?? fallbackChainId]?.swapDefaultTo[0] ?? pinnedTokens[fallbackChainId].swapDefaultFrom[0],
  };
};
